import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuilding, faPhone, faEnvelope, faLocationDot, faClock,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import brasao from '../assets/brasao.png';
import '../styles/header-footer.scss';

function Footer() {
    return (
        <footer className="ftr">
            <div className="ftr__marca">
                <img src={brasao} className="ftr__brasao" alt="Brasão de Duas Barras" />
                <div className="ftr__nome">
                    <span className="ftr__pref">Prefeitura Municipal de</span>
                    <span className="ftr__municipio">DUAS BARRAS</span>
                </div>
            </div>

            <div className="ftr__corpo">
                <Container>
                    <Row xs={1} lg={3} className="g-4">
                        <Col>
                            <p className="ftr__col-titulo">Institucional</p>
                            <div className="ftr__linha">
                                <FontAwesomeIcon className="ftr__icone" icon={faBuilding} />
                                <p className="ftr__info">CNPJ: 28.564.177/0001-30</p>
                            </div>
                        </Col>
                        <Col>
                            <p className="ftr__col-titulo">Contatos</p>
                            <div className="ftr__linha">
                                <FontAwesomeIcon className="ftr__icone" icon={faPhone} />
                                <p className="ftr__info">(22) 2534-1212</p>
                            </div>
                            <div className="ftr__linha">
                                <FontAwesomeIcon className="ftr__icone" icon={faEnvelope} />
                                <p className="ftr__info">faleconosco@duasbarras.rj.gov.br</p>
                            </div>
                        </Col>
                        <Col>
                            <p className="ftr__col-titulo">Endereço e Horário</p>
                            <div className="ftr__linha">
                                <FontAwesomeIcon className="ftr__icone" icon={faLocationDot} />
                                <p className="ftr__info">
                                    Praça Governador Portela, 7, Centro — CEP 28650-000 — Duas Barras/RJ
                                </p>
                            </div>
                            <div className="ftr__linha">
                                <FontAwesomeIcon className="ftr__icone" icon={faClock} />
                                <p className="ftr__info">Segunda à Sexta, das 9h às 17h</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container>
                <div className="ftr__base">
                    <div className="ftr__social">
                        <a className="ftr__social-link" href="https://webmail.duasbarras.rj.gov.br" target="_blank" rel="noreferrer" title="Webmail" aria-label="Webmail">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                        <a className="ftr__social-link" href="https://www.facebook.com/prefeituraduasbarrasrj" target="_blank" rel="noreferrer" title="Facebook" aria-label="Facebook">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                        <a className="ftr__social-link" href="https://www.instagram.com/prefeitura_duasbarras/" target="_blank" rel="noreferrer" title="Instagram" aria-label="Instagram">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                    </div>
                    <p className="ftr__copy">
                        © {new Date().getFullYear()} Prefeitura Municipal de Duas Barras — Secretaria de Meio Ambiente
                    </p>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
